import { render, staticRenderFns } from "./BillingTab.vue?vue&type=template&id=7622f444"
import script from "./BillingTab.vue?vue&type=script&lang=ts"
export * from "./BillingTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports